export enum CALENDAR_MODE {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
  RANGE = 'range',
}
